import { Field, Float, ID, InputType, Int, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { RelatedEntity } from '../base/RelatedEntity'
import { Product } from '../product/Product'
import { generateEntityId } from '../generateEntityId'

/**
 * Embedded sub-document for work order insufficient items.
 * Stored on WorkOrder at creation time via computeBomAsGreedy + summarizeBom.
 * Cost is manually editable (default 0). Sum of all costs = subAssemblyCost.
 */
@ObjectType()
@InputType('WorkOrderInsufficientItemInput')
export class WorkOrderInsufficientItem {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('woii') })
  _id: string

  @Field(() => Product)
  @Prop({ type: RelatedEntity })
  product: ReturnType<() => Product>

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number, default: 0 })
  qtyNeededToBuild: number

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number, default: 0 })
  cost: number

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number, default: 0 })
  decimalPrecision: number
}
